import { ExtraWorkCountFields } from "./ExtraWorkField";

export const HideableOrderField = {
	// ETA block
	ETA_3RD_PARTY: "eta_3rd_party",
	ETA_4TH_PARTY: "eta_4th_party",
	PLACE_FROM: "place_from",
	PLACE_FROM_COUNTRY_CODE: "place_from_country_code",
	SEAL: "seal",
	SEAL_NUMBER: "seal_number",
	INCOMING_TRIP_NUMBER: "incoming_trip_number",
	UNLOADING_SEQUENCE: "unloading_sequence",
	ETA_TRUCK: "eta_truck",
	ETA_TRAILER: "eta_trailer",
	ETA_DRIVER: "eta_driver",
	ETA_DRIVER_PHONE: "eta_driver_phone",
	ETA_SHOW_DOC_FOR_TRANS: "eta_show_doc_for_trans",
	COOLER_TYPE_ID: "cooler_type_id",
	PALLETS: "pallets",
	BOXES: "boxes",
	KILOS: "kilos",
	COMMODITY_ID: "commodity_id",
	ASSIGNEE_1: "assignee_1",

	// ETD block
	ETD_3RD_PARTY: "etd_3rd_party",
	ETD_4TH_PARTY: "etd_4th_party",
	PLACE_TO: "place_to",
	PLACE_TO_COUNTRY_CODE: "place_to_country_code",
	PLUMB: "plumb",
	PLUMB_NUMBER: "plumb_number",
	OUTGOING_TRIP_NUMBER: "outgoing_trip_number",
	LOADING_SEQUENCE: "loading_sequence",
	ETD_TRUCK: "etd_truck",
	ETD_TRAILER: "etd_trailer",
	ETD_DRIVER: "etd_driver",
	ETD_DRIVER_PHONE: "etd_driver_phone",
	ETD_SHOW_DOC_FOR_TRANS: "etd_show_doc_for_trans",
	IS_AREA_BLOCKED: "is_area_blocked",
	LABEL_SOURCE: "label_source",
	LABEL: "label",
	ASSIGNEE_2: "assignee_2",
	ASSIGNEE_3: "assignee_3",

	// Split Load (primary field - hides dependent fields automatically)
	SPLIT_LOAD: "split_load",

	// Extra Loading Time (primary field - hides billable checkbox automatically)
	EXTRA_LOADING_TIME: "extra_loading_time",

	// Document fields
	IS_DOC_FOR_NFSA: "is_doc_for_nfsa",
	PRINTED_DOC: "printed_doc",

	// PER flag
	IS_PER: "is_per",
};

export const FieldDependencies = {
	// When split_load is hidden, also hide outgoing_trip_number and loading_sequence
	[HideableOrderField.SPLIT_LOAD]: [
		HideableOrderField.OUTGOING_TRIP_NUMBER,
		HideableOrderField.LOADING_SEQUENCE,
	],

	[HideableOrderField.EXTRA_LOADING_TIME]: [
		"is_extra_loading_time_billable",
		...ExtraWorkCountFields,
	],

	// 4th party is disabled until a 3rd party is chosen, so it dies with it
	[HideableOrderField.ETA_3RD_PARTY]: [HideableOrderField.ETA_4TH_PARTY],
	[HideableOrderField.ETD_3RD_PARTY]: [HideableOrderField.ETD_4TH_PARTY],

	[HideableOrderField.SEAL]: [HideableOrderField.SEAL_NUMBER],
	[HideableOrderField.PLUMB]: [HideableOrderField.PLUMB_NUMBER],

	[HideableOrderField.ETA_DRIVER]: [HideableOrderField.ETA_DRIVER_PHONE],
	[HideableOrderField.ETD_DRIVER]: [HideableOrderField.ETD_DRIVER_PHONE],

	// label is disabled until a label source is chosen
	[HideableOrderField.LABEL_SOURCE]: [HideableOrderField.LABEL],
};

// Some fields have aliases/synonyms used in different parts of the UI/export.
// Keep them in sync so visibility logic hides all representations.
const SynonymPairs = [
	[HideableOrderField.SPLIT_LOAD, "split"],
	[HideableOrderField.OUTGOING_TRIP_NUMBER, "split_trip_no"],
	[HideableOrderField.LOADING_SEQUENCE, "load_no"],
	[HideableOrderField.PLACE_FROM, "eta_external_terminal_id"],
	[HideableOrderField.PLACE_TO, "etd_external_terminal_id"],
];

const buildFieldSynonyms = () => {
	const synonymsByField = {};
	const addSynonym = (fieldName, synonym) => {
		synonymsByField[fieldName] = [...(synonymsByField[fieldName] ?? []), synonym];
	};
	SynonymPairs.forEach(([fieldName, synonym]) => {
		addSynonym(fieldName, synonym);
		addSynonym(synonym, fieldName);
	});
	return synonymsByField;
};

export const FieldSynonyms = buildFieldSynonyms();

const FieldLabelOverrides = {
	[HideableOrderField.ETA_SHOW_DOC_FOR_TRANS]: "resources.orders.fields.eta_show_doc",
	[HideableOrderField.ETD_SHOW_DOC_FOR_TRANS]: "resources.orders.fields.etd_show_doc",
};

export const HideableOrderFieldChoices = Object.values(HideableOrderField).map((fieldName) => ({
	id: fieldName,
	name: FieldLabelOverrides[fieldName] || `resources.orders.fields.${fieldName}`,
}));

export default HideableOrderField;
